import React from 'react';
import { type IAutoSuggestParamsContextShape } from '../../types/autoSuggestTypes';

export const AutoSuggestContext = React.createContext<IAutoSuggestParamsContextShape | null>(null);

export default AutoSuggestContext;
